module.exports = __webpack_public_path__ + "frontend/img/icon_office.6cc81ef3.svg";